import styled from 'styled-components';

const colors = require('common/lib/colors/colors.less');

export const ActionPanelRow = styled.div`
  border-bottom: 1px solid ${colors.N40};
  padding: ${({ slim = false }) => (slim ? '4px' : '8px')};
  text-align: ${({ alignRight = false }) => (alignRight ? 'right' : 'left')};

  * {
    vertical-align: middle;
  }
`;

export const ActionPanel = styled.div`
  background-color: ${colors.N30};
  border-radius: 3px;
  border: ${({ hideBorder }) =>
    hideBorder ? 'none' : `solid 1px ${colors.N40}`};

  ${ActionPanelRow}:last-child {
    border-bottom: none;
  }
`;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-card/ActionPanel.js